import { render, staticRenderFns } from "./popup-save.vue?vue&type=template&id=5c6dcd20&scoped=true"
import script from "./popup-save.vue?vue&type=script&lang=js"
export * from "./popup-save.vue?vue&type=script&lang=js"
import style0 from "./popup-save.vue?vue&type=style&index=0&id=5c6dcd20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6dcd20",
  null
  
)

export default component.exports